import type { BaseController } from '@infra/controllers/base.controller';
import type {
  SupervisorDisconnectRequest,
  SupervisorDisconnectUsecase,
} from './supervisor-disconnect.usecase';

export class SupervisorDisconnectController
  implements BaseController<SupervisorDisconnectRequest, void>
{
  constructor(private usecase: SupervisorDisconnectUsecase) {}

  async handle(request: SupervisorDisconnectRequest): Promise<void> {
    await this.usecase.run(request);
  }
}
